import { render, staticRenderFns } from "./Avulsa.vue?vue&type=template&id=3edcb73e&lang=pug&"
import script from "./Avulsa.vue?vue&type=script&lang=js&"
export * from "./Avulsa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports